<template>
  <div class="dialog-wrap">
    <el-dialog title="用户添加"
               :close-on-click-modal="false"
               :visible.sync="dialogVisible"
               @close="handleClose"
               width="480px">
      <el-form class="form"
               :model="dataForm"
               :rules="rules"
               ref="dataForm"
               label-width="100px">
        <el-form-item label="昵称"
                      prop="nickname">
          <el-input v-model="dataForm.nickname"
                    placeholder="输入用户昵称"></el-input>
        </el-form-item>
        <el-form-item label="真实姓名"
                      prop="realname">
          <el-input v-model="dataForm.realname"
                    placeholder="输入用户真实姓名"></el-input>
        </el-form-item>
        <el-form-item label="手机号"
                      prop="mobile">
          <el-input v-model="dataForm.mobile"
                    placeholder="输入用户手机号"></el-input>
        </el-form-item>
        <el-form-item label="登录密码"
                      prop="password">
          <el-input type="password"
                    v-model="dataForm.password"
                    placeholder="输入用户登录密码"></el-input>
        </el-form-item>
        <el-form-item label="帐号状态"
                      prop="status">
          <el-switch v-model="dataForm.status"></el-switch>
        </el-form-item>
      </el-form>
      <div slot="footer"
           class="dialog-footer">
        <el-button @click="handleClose">取 消</el-button>
        <el-button type="primary"
                   @click="handleSubmit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { memberCreate } from '@/api/member'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: this.visible,
      dataForm: {
        status: true,
      },
      rules: {
        nickname: [
          { required: false, message: '请输入用户昵称', trigger: 'blur' },
        ],
        mobile: [
          {
            required: true,
            message: '请输入用户手机号',
            trigger: 'blur',
            pattern: /^[0-9]{11}$/,
          },
        ],
        password: [
          {
            required: true,
            message: '请输入用户登录密码',
            trigger: 'blur',
            min: 6,
          },
        ],
      },
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
  },
  methods: {
    handleSubmit() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, this.dataForm, {
            status: this.dataForm.status ? 1 : 0,
          })

          params.admin_inviter_invitecode = JSON.parse(
            localStorage.getItem('admin_user')
          ).invitecode

          memberCreate(params)
            .then((res) => {
              this.$message.success(`添加成功`)
              this.$refs['dataForm'].resetFields()
              this.$emit('submit')
              this.handleClose()
            })
            .catch((error) => {
              console.log('error: ', error)
            })
        } else {
          console.log('error submit!!')
          return false
        }
      })
    },
    handleClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="less" scoped>
.dialog-wrap {
  .form {
    margin-bottom: -18px;
  }
}
</style>
